export default __webpack_public_path__ + "static/img04-88a6aa684ec84649ec4b970d18546314.webp";